'use client';
import cn from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { PropsWithChildren } from 'react';

import { useTOCDataCtx } from '@/hooks/ctx';
import { NavItemType } from '@/types/navigation';
import { equals } from '@/utils/common';
import { checkIsActiveNavigationItem } from '@/utils/navigation';

import s from './style.module.scss';

type ListCollapseWrapperProps = PropsWithChildren<{
  itemType: NavItemType;
  itemLink: string;
}>;

export function ListCollapseWrapper({ children, itemType, itemLink }: ListCollapseWrapperProps) {
  const { activeTOCElement } = useTOCDataCtx();
  const pathname = usePathname();

  if (equals(itemType, 'sidebar')) {
    return (
      <Link
        href={itemLink}
        className={cn(s.links_wrapper, {
          [s.active_element]: checkIsActiveNavigationItem(itemType, {
            pathname,
            url: itemLink,
          }),
        })}
      >
        {children}
      </Link>
    );
  }

  return (
    <div
      className={cn({
        [s.active_element]: checkIsActiveNavigationItem(itemType, {
          currentItemID: itemLink,
          selectedAnchor: activeTOCElement,
        }),
      })}
    >
      {children}
    </div>
  );
}
